// src/components/ui/GinoriTitle.tsx
import React from 'react';
import { Title, TitleProps, Box } from '@mantine/core';

interface GinoriTitleProps extends TitleProps {
  subtitle?: string;
  elegant?: boolean;
  centered?: boolean;
}

export function GinoriTitle({ 
  subtitle, 
  elegant = false,
  centered = false,
  children,
  ...props 
}: GinoriTitleProps) {
  return (
    <Box 
      style={{
        textAlign: centered ? 'center' : 'left',
        marginBottom: '2rem',
      }}
    >
      <Title
        order={1}
        style={{
          fontFamily: elegant ? '"Playfair Display", serif' : 'var(--font-family-primary)',
          fontWeight: elegant ? 300 : 300,
          letterSpacing: elegant ? '0.5px' : '-0.01em',
          color: 'var(--mantine-color-ginoriBlue-8)',
          marginBottom: subtitle ? '0.5rem' : '1rem',
          fontSize: elegant ? '2.5rem' : '2rem',
          lineHeight: 1.2,
        }}
        {...props}
      >
        {children}
      </Title>
      
      {subtitle && (
        <Box
          style={{
            fontFamily: 'var(--font-family-secondary)',
            fontSize: '1.125rem',
            fontWeight: 400,
            color: 'var(--mantine-color-ginoriBlue-6)',
            letterSpacing: '0.3px',
            lineHeight: 1.5,
            marginTop: '0.5rem',
          }}
        >
          {subtitle}
        </Box>
      )}
    </Box>
  );
}
